import Vue from "vue";
import Router from "vue-router";

import Service from "./services";

const MainLayout = () => import("@/layouts/MainLayout.vue");
const Login = () => import("@/views/Login.vue");
const AuthLogin = () => import("@/views//auth/Login.vue");
const TemporaryDisable = () => import("@/views/TemporaryDisable.vue");
const Home = () => import("@/views/Home.vue");
const LiveOrders = () => import("@/views/order/Live.vue");
const DineinOrders = () => import("@/views/order/Dinein.vue");
const ScheduledOrders = () => import("@/views/order/Scheduled.vue");
const ClusterOrders = () => import("@/views/order/Cluster.vue");
const CreateOrder = () => import("@/views/order/Create.vue");
const ViewOrder = () => import("@/views/order/Detail.vue");
const ViewShop = () => import("@/views/shop/Detail.vue");
const ViewEnterprise = () => import("@/views/enterprise/Detail.vue");
const ViewProduct = () => import("@/views/product/Detail.vue");

const CreateSell = () => import("@/views/sell/Create.vue");

const ShopsList = () => import("@/views/shop/List.vue");
const ProductList = () => import("@/views/product/List.vue");
const EnterprisesList = () => import("@/views/enterprise/List.vue");

const Drivers = () => import("@/views/driver/Index.vue");
const DriversMap = () => import("@/views/driver/Map.vue");
const PoiList = () => import("@/views/poi/List.vue");
const PoiDetail = () => import("@/views/poi/Detail.vue");
const PostList = () => import("@/views/post/List.vue");
const PostCreate = () => import("@/views/post/Create.vue");
const PostDetail = () => import("@/views/post/Detail.vue");

const CommerceOrders = () => import("@/views/commerce/order/Live.vue");
const CommerceOrdersButchery = () => import("@/views/commerce/order/Butchery.vue");
const CommerceOrdersSearch = () => import("@/views/commerce/order/Search.vue");

const CommerceViewOrder = () => import("@/views/commerce/order/Detail.vue");
const CreateCommerceOrder = () => import("@/views/commerce/order/Create.vue");

const Warehouse = () => import("@/views/commerce/Warehouse.vue");
const ProductToPack = () => import("@/views/report/ProductToPack.vue");

const CommerceProducts = () => import("@/views/commerce/product/List.vue");
const CreateCommerceProduct = () =>
  import("@/views/commerce/product/Create.vue");

const HeatMap = () => import("@/views/report/HeatMap2.vue");
const SaleReport = () => import("@/views/report/Sale.vue");
const SaleReport2025 = () => import("@/views/report/Sale2025.vue");
const ProductReport = () => import("@/views/report/Product.vue");
const ProductStockReport = () => import("@/views/report/ProductStock.vue");
const LogbookReport = () => import("@/views/report/Logbook.vue");
const ShopReport = () => import("@/views/report/Shop.vue");
const CategoryReport = () => import("@/views/report/Category.vue");
const OrderChannelReport = () => import("@/views/report/OrderChannel.vue");
const SocialFacebook = () => import("@/views/social/Facebook.vue");
const GPReport = () => import("@/views/report/GP.vue");
const GPAdminReport = () => import("@/views/report/GPAdmin.vue");
const DriverAdminReport = () => import("@/views/report/DriverAdmin.vue");
const Location = () => import("@/views/report/Location.vue");
const Payments = () => import("@/views/report/Payments.vue");
const PaymentGateway = () => import("@/views/report/PaymentGateway.vue");


const LiveCommerce = () => import("@/views/live-commerce/Index.vue");
const LiveCommercePage = () => import("@/views/live-commerce/Dash.vue");
const LiveCommerceVideoPage = () => import("@/views/live-commerce/Video.vue");
const Conversation = () => import("@/views/live-commerce/Conversation.vue");

const Members = () => import("@/views/member/Index.vue");
const Transaction = () => import("@/views/member/Transaction.vue");
const Redemption = () => import("@/views/member/Redemption.vue");
const Earn = () => import("@/views/member/Earn.vue");

const Company = () => import("@/views/Company.vue");
const Team = () => import("@/views/team/Index.vue");
const TeamSales = () => import("@/views/team/Sales.vue");
const Print = () => import("@/views/Print.vue");

const DepositList = () => import("@/views/wallet/DepositList.vue");
/*
const PosView = () =>
    import ('@/views/pos/index.vue')
    */

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/auth/login",
      name: "auth-login",
      component: AuthLogin,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/temporary-disable",
      name: "temporary-disable",
      component: TemporaryDisable,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/",
      name: "MainLayout",
      component: MainLayout,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/",
          name: "Home",
          component: Home,
        },
        {
          path: "/orders/live",
          name: "LiveOrders",
          component: LiveOrders,
        },
        {
          path: "/orders/dinein",
          name: "DineinOrders",
          component: DineinOrders,
        },
        {
          path: "/orders/schedule",
          name: "ScheduleOrders",
          component: ScheduledOrders,
        },
        {
          path: "/orders/cluster",
          name: "ClusterOrders",
          component: ClusterOrders,
          props: true,
        },
        {
          path: "/orders/create",
          name: "CreateOrder",
          component: CreateOrder,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/orders/:order_ref/view",
          name: "ViewOrder",
          component: ViewOrder,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/sell/create",
          name: "CreateSell",
          component: CreateSell,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "shop/:ref_no/view",
          name: "ViewShop",
          component: ViewShop,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/view/enterprise/:reference",
          name: "ViewEnterprise",
          component: ViewEnterprise,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "product/:product_id/view",
          name: "ViewProduct",
          component: ViewProduct,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/shops",
          name: "ShopsList",
          component: ShopsList,
        },
        {
          path: "/live-commerce",
          name: "LiveCommerce",
          component: LiveCommerce,
        },
        {
          path: "/live-commerce/:page_id",
          name: "LiveCommercePage",
          component: LiveCommercePage,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/live-commerce/:page_id/conversations",
          name: "Conversation",
          component: Conversation,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/live-commerce/:page_id/videos",
          name: "LiveCommerceVideoPage",
          component: LiveCommerceVideoPage,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/members/index",
          name: "MemberList",
          component: Members,
        },
        {
          path: "/members/transactions",
          name: "Transaction",
          component: Transaction,
        },
        {
          path: "/members/earn",
          name: "Earn",
          component: Earn,
        },
        {
          path: "/members/redemption",
          name: "Redemption",
          component: Redemption,
        },
        {
          path: "/pois",
          name: "PoiList",
          component: PoiList,
        },
        {
          path: "/pois/view/:poi_id",
          name: "PoiDetail",
          component: PoiDetail,
          props: true,
        },
        {
          path: "/products",
          name: "ProductList",
          component: ProductList,
        },
        {
          path: "/drivers/list",
          name: "Drivers",
          component: Drivers,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/drivers/map",
          name: "DriversMap",
          component: DriversMap,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/posts",
          name: "PostList",
          component: PostList,
        },
        {
          path: "/posts/create",
          name: "PostCreate",
          component: PostCreate,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/posts/:post_slug",
          name: "PostDetail",
          component: PostDetail,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/social/facebook",
          name: "SocialFacebook",
          component: SocialFacebook,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/enterprises",
          name: "EnterprisesList",
          component: EnterprisesList,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/heatmap",
          name: "HeatmapReport",
          component: HeatMap,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/sale",
          name: "SaleReport",
          component: SaleReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/sale_v2025",
          name: "SaleReport2025",
          component: SaleReport2025,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/category",
          name: "CategoryReport",
          component: CategoryReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/order_channel",
          name: "OrderChannelReport",
          component: OrderChannelReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/shop",
          name: "ShopReport",
          component: ShopReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/product",
          name: "ProductReport",
          component: ProductReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/product-stock",
          name: "ProductStockReport",
          component: ProductStockReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/logbook",
          name: "LogbookReport",
          component: LogbookReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/gp",
          name: "GPReport",
          component: GPReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/admin_gp",
          name: "GPAdminReport",
          component: GPAdminReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/admin_driver",
          name: "DriverAdminReport",
          component: DriverAdminReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/location",
          name: "Location",
          component: Location,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/payments",
          name: "Payments",
          component: Payments,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/report/payment_gateway",
          name: "Payments",
          component: PaymentGateway,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/orders/butchery",
          name: "CommerceOrdersButchery",
          component: CommerceOrdersButchery,
          meta: {
            requiresAuth: true,
          },
        },

        {
          path: "/commerce/orders/search",
          name: "CommerceOrdersSearch",
          component: CommerceOrdersSearch,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/orders/live",
          name: "CommerceOrders",
          component: CommerceOrders,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/orders/create",
          name: "CreateCommerceOrder",
          component: CreateCommerceOrder,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/view/order/:order_ref",
          name: "CommerceViewOrder",
          component: CommerceViewOrder,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/wh",
          name: "Warehouse",
          component: Warehouse,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/wh/to_pack",
          name: "ProductToPack",
          component: ProductToPack,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/products",
          name: "CommerceProducts",
          component: CommerceProducts,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/commerce/create/product",
          name: "CreateCommerceProduct",
          component: CreateCommerceProduct,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/company",
          name: "Company",
          component: Company,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/team",
          name: "Team",
          component: Team,
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: "sales",
              name: "TeamSales",
              component: TeamSales,
            },
          ],
        },
        {
          path: "/print",
          name: "Print",
          component: Print,
          meta: {
            requiresAuth: true,
          },
        },

        {
          path: "/wallets/req",
          name: "req-deposit",
          component: DepositList,
          props: true,
          meta: {
            title: "รายการเติมเงิน",
          },
        },
      ],
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    if (!localStorage.getItem("pro-halalize")) {
      next({
        path: "/auth/login",
        params: {
          nextUrl: to.fullPath,
        },
      });
    } else {
      let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
      let accessToken = vuex.Auth.accessToken;

      Service.Auth.me(accessToken)
        .then((response) => {
          if (response.status != "ok") {
            next({
              path: "/auth/login",
              params: {
                nextUrl: to.fullPath,
              },
            });
          } else {
            Service.User.me().then((rs) => {
              if (rs.data.errors.length > 0) {
                next({
                  path: "/temporary-disable",
                });
              } else {
                next();
              }
            });
            next();
          }
        })
        .catch((err) => {
          next({
            path: "/auth/login",
            params: {
              nextUrl: to.fullPath,
            },
          });
        });
    }
  } else {
    next();
  }
});

export default router;
